/**
 * Android TV WebViews often deliver D-pad as `key: "Unidentified"` plus a legacy `keyCode`.
 * KEYCODE_DPAD_* / ENTER — see android.view.KeyEvent.
 */
const KEY_CODE_NAMES: Record<number, string> = {
  19: 'ArrowUp',
  20: 'ArrowDown',
  21: 'ArrowLeft',
  22: 'ArrowRight',
  // Android KEYCODE_DPAD_CENTER. Chromium also reports DOM keyCode 13 ("Enter").
  13: 'Enter',
  23: 'Enter',
  66: 'Enter',
  160: 'NumpadEnter',
  4: 'Escape',
  111: 'Escape',
  67: 'Backspace'
}

export function androidRemoteKey(evt: { key?: string, keyCode?: number }): string {
  const key = evt.key ?? ''
  if (key && key !== 'Unidentified') {
    return key
  }
  return KEY_CODE_NAMES[evt.keyCode ?? 0] ?? key
}

/** OK / D-pad center / Enter. Ignores key-repeat from a held button. */
export function isRemoteSelectKey(evt: { key?: string, keyCode?: number, repeat?: boolean }): boolean {
  if (evt.repeat) {
    return false
  }
  const key = androidRemoteKey(evt)
  return key === 'Enter' || key === 'NumpadEnter'
}
